"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _constants = require("../../utils/constants");
var _useAppSelector = require("../useAppSelector");
const useComparisonSettings = () => {
  const {
    showComparisonForDevices,
    showComparisonForPlans,
    showComparisonForBroadbands,
    multipleValueCharacteristics,
    showComparisonBusinessSolution
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectComparisonSettings);
  const {
    flags
  } = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectMetadata);
  const shouldHideComparisonPlans = flags === null || flags === void 0 ? void 0 : flags[_constants.ALTERNATIVE_RECOMMENDATION_FLAGS.ALTERNATIVE_PLANS_FLAG];
  return {
    showComparisonDevices: showComparisonForDevices,
    showComparisonPlans: showComparisonForPlans && !shouldHideComparisonPlans,
    showComparisonBroadbands: showComparisonForBroadbands,
    showComparisonBusinessSolution: showComparisonBusinessSolution,
    multipleValueCharacteristics
  };
};
var _default = useComparisonSettings;
exports.default = _default;